import { createReducer, on } from '@ngrx/store';
import { SignalRData } from '../common-admin.model';
import { disconnect, setDomainMessageReceived, updateConnectionState } from './signalr.actions';

export const initialSignalRState: SignalRData = {};

export const signalrReducer = createReducer<SignalRData>(
  initialSignalRState,
  on(
    updateConnectionState,
    (state: SignalRData, { payload, error }): SignalRData => ({
      ...state,
      connectionState: payload,
      lastError: error,
    }),
  ),
  on(
    setDomainMessageReceived,
    (state: SignalRData, { payload }): SignalRData => ({
      ...state,
      domainMessage: payload,
    }),
  ),
  on(disconnect, (state: SignalRData): SignalRData => {
    return { ...state };
  }),
);
